<template lang="pug">
	v-card.padding
		h1.fonte NOVA CAMPANHA
		p.black--text Importe sua base de dados em csv

		div(style='margin-top:30px')
			v-layout(align-center='', justify-center='', row='', fill-height='')
				v-text-field(label="Titulo da campanha" color="blue-grey" box)

			input#imgimport(type='file', @change='processImage($event)', v-show='false', accept='image/*')
			v-btn.white--text(color='fundo' @click.native='actionImgImport')
				| Imagem &nbsp;
				v-icon(dark) backup
			| {{imagem.name}}
			br
			strong Variáveis de ambiente:
			v-chip $nome
			v-chip $sobrenome
			v-layout(align-center='', justify-center='', row='', fill-height='')
				v-textarea(solo box label="Campanha")
		v-divider.mt-3

		v-progress-linear(v-if='enviando', :indeterminate='true')
		h1(v-if='enviando') Aguarde, enviando arquivo...

		div(v-if='!enviando'  style="margin-top:50px")
			v-alert(:value='titulos.length == 0', color='teal', outline, type='info') Importe um arquivo .CSV com vários telefones
				span(v-if='sizeFile')
					v-icon attachment
					| {{sizeFile}}
		v-spacer

		v-btn(@click='dialog=true', v-if='sizeFile', dark='', color='teal')
			| Identificar Telefone

		input#import(type='file', @change='processFile($event)', v-show='false', accept='.csv')
		v-btn#btnimport.white--text(@click.native='actionImport', color='fundo', v-if='titulos.length == 0')
			| Importar CSV  &nbsp;
			v-icon(dark='') backup
		v-chip(v-if='titulos.length > 0', :key='i', v-for='(t, i) in telefones', @click='telefones.splice(i,1)') {{ 'ddd: ' + t.ddd + '- número: ' + t.numero }}

		v-divider.mt-5
		v-card-actions
			v-spacer
			v-btn(color="fundo" class="white--text") Gerar Campanha

		v-dialog(v-model='loading', hide-overlay, persistent='', width='300')
			v-card.white--text(color='blue-grey', dark='')
				v-card-text
					| Por favor, Aguarde!
					v-progress-linear.mb-0(indeterminate='', color='white')

		v-dialog(v-model='dialog', max-width='290')
			v-card
				v-card-title.headline Identifique as colunas
				v-card-text
					v-select(label='DDD', :items='getTitlesDdd', v-model='tempDdd')
					v-select(label='NÚMERO (Obrigatório)', :items='getTitlesFone', v-model='tempFone')
				v-card-actions
					v-spacer
					v-btn(color='error', flat='flat', @click='dialog=false') Cancelar
					v-btn(color='blue-grey', flat='flat', @click='addFone') Adicionar

</template>


<script>
import Papa from 'papaparse'
import axios from 'axios'
import moment from 'moment'
import {mapActions} from 'vuex'

export default {
  data () {
    return {
      enviando:false,
      loading:false,
      dialog:false,
      tempDdd:'',
      tempFone:'',
      grupos: [
        {campo:"nome", is:["nom"], not:[], selected:''}
      ],
      mensagem:'',
      dados:[],
      telefones:[],
      titulos:[],
      sizeFile:'',
      nameFile:'',
      datefile:'',
      arquivo:null,
      imagem:{}
    }
  },
  methods: {
    ...mapActions([]),
    addFone()
    {
      if( !this.tempFone ) return alert("Falta telefone!")
      this.telefones.push( {ddd:this.tempDdd, numero: this.tempFone} )
      this.tempDdd=''
      this.tempFone=''
    },
    reset()
    {
      this.dados    = []
      this.titulos  = []
      this.telefones=[]
    },
    actionImport()
    {
      document.querySelector("#import").click()
    },
    actionImgImport()
    {
      document.querySelector("#imgimport").click()
    },
    processImage(event)
    {
      this.imagem = event.currentTarget.files[0]
      //console.log( this.imagem )
    },
    processFile(event)
    {
      moment.locale('pt-br')
      this.loading=true
      this.reset()

      this.arquivo = event.target.files[0]
      this.nameFile= this.arquivo.name
      this.sizeFile= ((this.arquivo.size / 1024) / 1024).toString().substr(0,7) + " MB"
      this.datefile= moment( this.arquivo.lastModified ).format('LL')

      Papa.parse(this.arquivo, {
        complete: results => {
          this.dados     = results.data[1]
          this.titulos   = results.data[0]
          this.titulos.push('')
          this.loading=false
        }
      })
    },
    getTitles( info )
    {
      return this.titulos
    },
    send()
    {
      let grupos= this.grupos.map( g => {return { campo:g.campo, index: this.getIndex(g.selected) }} )

      let dados =  {
        novonome:this.nameFile,
        colunas: grupos
      }

      let formData = new FormData()
      formData.append("planilha", this.arquivo)
      formData.append("dados", JSON.stringify(dados))

      this.enviando=true
      /*this.arquivos_saveArquivo(formData).then(r => {
        if( r.status )this.$eventHub.emit('snackBar', "Servidor processando o arquivo")
        else this.$eventHub.emit('snackBar', "Erro ao enviar")

        this.enviando=false
      })
      .catch(err=> this.enviando=false )*/

    },
    getIndex( col )
    {
      if(!col)return -1
      return this.titulos.findIndex( (item, index) => item.toLowerCase() === col.toLowerCase() )
    }
  },
  computed:{
    getTitlesFone()
    {
      //retornar colunas que: não foram selecionadas no form e não estão em telefones
      return this.titulos.filter( t => {
        return  this.grupos.filter( g => g.selected.toLowerCase() == t.toLowerCase() ).length == 0
                && this.telefones.filter( f => f.numero.toLowerCase() == t.toLowerCase() || f.ddd.toLowerCase() == t.toLowerCase() ).length == 0
                || t == ''
      })
    },
    getTitlesDdd()
    {
      //retornar colunas que: não foram selecionadas no form e não estão em telefones
      return this.titulos.filter( t => {
        return  this.grupos.filter( g => g.selected.toLowerCase() == t.toLowerCase() ).length == 0
                && this.telefones.filter( f => f.numero.toLowerCase() == t.toLowerCase() || f.ddd.toLowerCase() == t.toLowerCase() ).length == 0
                || t == ''
      })
    }
  }
}
</script>

<style scoped lang="stylus">
  #btnimport
    display block
    margin-top 30px



</style>





// WEBPACK FOOTER //
// src/components/user/push/NovaCampanha.vue